import React from 'react';

import { Row, Column, Margin, Link } from '@upgrade/react-components';

import { Section, SectionTitle } from '../styles';
import Fluid from '../../Fluid';
import { Carousel } from './styles';
import { StyledLink } from '../typography';
import useTrustpilot from '../../../utils/useTrustpilot';

const Reviews = ({
  reviews: { title, snippet, CTAText, link },
  padding = 'sm',
  borderless,
  CarouselBottomMargin = { xs: 'lg' }
}) => {
  useTrustpilot();

  return (
    <Section data-color="backgroundPrimary" {...{ padding, borderless }}>
      <Fluid>
        <Row xsHorizontalAlign="center">
          <Column xs={12} sm={10}>
            {title && <SectionTitle className="section">{title}</SectionTitle>}
            <Row xsHorizontalAlign="center">
              <Column xs={12} xsHorizontalAlign="center" mdHorizontalAlign="end">
                <Carousel>
                  <Margin bottom={CarouselBottomMargin} dangerouslySetInnerHTML={{ __html: snippet }} />
                </Carousel>
              </Column>
              {link && CTAText && (
                <Column xs={12}>
                  <Link anchorComponent={StyledLink} to={link}>
                    {CTAText}
                  </Link>
                </Column>
              )}
            </Row>
          </Column>
        </Row>
      </Fluid>
    </Section>
  );
};

export default Reviews;
